export default __webpack_public_path__ + "static/media/my_pr_top.8e4131d0.svg";